import { STATUS_PROGRESS_ORDER_STRING } from '@/shared/constants/common';

export function orderStatusString(
  status: keyof typeof STATUS_PROGRESS_ORDER_STRING
): string {
  return STATUS_PROGRESS_ORDER_STRING[status];
}
